module.exports = __webpack_public_path__ + "img/advantage4.d5a1a532.png";